function importAll(r) {
  return r.keys().map(r);
}

const videos = importAll(
  require.context("../videos", false, /\.(mp4|mov|webm)$/)
);

export default videos;
